export const omitNil = <TObject extends Record<string, unknown>>(
  object: TObject,
): Partial<TObject> =>
  Object.fromEntries(
    Object.entries(object).filter(([_key, value]) => value !== null && value !== undefined),
  ) as Partial<TObject>;
